import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";

//Parsing Jd
import {
  ADD_JOB,
  ADD_LOCATION,
  BULK_IMPORT_SUGGESTION,
  GET_COUNTRIES,
  GET_JOB_DATA,
  GET_JOB_DEGREES,
  GET_JOB_INDUSTRIES,
  GET_ORGANIZATION_DETAIL_JOB,
  GET_QUALIFICATION,
  GET_STATE,
  GET_TAXONOMY_JOBDESCRIPTION,
  GET_TAXONOMY_JOBPROFILE,
  GET_TAXONOMY_JOBSKILL,
  JOB_GET_IP_LOCATION,
  PARSING_JD,
  RECRUITER_ORGANIZATION_DETAIL_GET_LIST,
  UPDATE_JOB,
} from "./actionTypes";
import {
  UpdateJobFailed,
  UpdateJobSuccessful,
  addJobFailed,
  addJobSuccessful,
  addLocationFailed,
  addLocationSuccessful,
  getBulkImportSuggestionFailed,
  getBulkImportSuggestionSuccess,
  getJobDegreesFailed,
  getJobDegreesSuccess,
  getJobIndustriesFailed,
  getJobIndustriesSuccess,
  getJobsDataFailed,
  getJobsDataSuccessful,
  getQualificationFailed,
  getQualificationSuccessful,
  getRecruiterOrganizationListError,
  getRecruiterOrganizationListSuccess,
  getTaxonomyJobDescriptionFailed,
  getTaxonomyJobDescriptionSuccess,
  getTaxonomyJobProfileFailed,
  getTaxonomyJobProfileSuccess,
  getTaxonomyJobSKillFailed,
  getTaxonomyJobSKillSuccess,
  jobGetIpBasedLocationError,
  jobGetIpBasedLocationSuccess,
  parsingJdFailed,
  parsingJdSuccessful,
  setCountriesFailed,
  setCountriesSuccess,
  setOrganizationDetailSuccess,
  setOrganizationFailed,
  setStateFailed,
  setStateSuccess,
} from "./actions";

import {
  PostOrganizationList,
  getAllCounties,
  getCall,
  getIpLocation,
  getRequest,
  postAddNewJob,
  postGetJobData,
  postJdData,
  postProfileDetail,
  postQualificationList,
  postUpdateJob,
} from "../../../helpers/fakebackend_helper";
//restapi end point
import * as constClass from "../../../common/constant/constantURL";

// get Jd parsing
function* getParsingJd({ payload: { user } }) {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const companyId = authUser ? authUser.companyId : null;
    //calling Jd parser api
    // var fileName=user.fileName
    let url = constClass.REST_API_PARSE_JD;
    // var responseJSON = yield call(jdParsing, user.fileData, fileName);

    var responseJSON = yield call(postJdData, url, user, companyId);
    yield put(parsingJdSuccessful(responseJSON));
  } catch (error) {
    yield put(parsingJdFailed(error));
  }
}

//Add Job
function* addJobs({ payload: { user } }) {
  try {
    let data = JSON.parse(localStorage.getItem("authUser"));
    let data2 = localStorage.getItem("userType");
    var url;
    if (data.userType === "RECRUITER" || data2 === "Recruiter") {
      url = constClass.REST_API_RECRUITER_ADD_JOB;
    } else {
      url = constClass.REST_API_ADD_NEW_JOB;
    }

    var responsJSON = yield call(postAddNewJob, url, user);

    yield put(addJobSuccessful(responsJSON));
  } catch (error) {
    const message =
      error?.response?.data?.message || error?.message || "Failed to add job.";
    yield put(addJobFailed(message));
  }
}

//Get candidate Data
function* getJobData({ payload: { user } }) {
  try {
    let data = JSON.parse(localStorage.getItem("authUser"));
    let url;

    if (data.userType === "RECRUITER" || data.userType === "Recruiter") {
      url = `${constClass.REST_API_RECRUITER_GET_JOB_DATA}?id=${user}`;
    } else {
      url = constClass.REST_API_GET_JOB_DATA + user;
    }

    const responsJSON = yield call(postGetJobData, url);
    yield put(getJobsDataSuccessful(responsJSON));
  } catch (error) {
    yield put(getJobsDataFailed(error));
  }
}

//Get candidate Data
function* updateJobs({ payload: { user } }) {
  try {
    let data = JSON.parse(localStorage.getItem("authUser"));
    let data2 = localStorage.getItem("userType");
    var url;
    if (data.userType === "RECRUITER" || data2 === "Recruiter") {
      url = constClass.REST_API_RECRUITER_UPDATE_JOB;
    } else {
      url = constClass.REST_API_UPDATE_JOB;
    }

    //calling candidates count api
    var responsJSON = yield call(postUpdateJob, url, user);

    // yield put(getCandidateDataSuccessful(responsJSON))
    yield put(UpdateJobSuccessful(responsJSON));
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to update job.";
    yield put(UpdateJobFailed(message));
  }
}
//get qualification list
function* getQualification({ payload: { user } }) {
  try {
    //calling resume parser api
    var url = constClass.REST_API_GET_QUALIFICATION;
    url = user !== undefined ? url + "?recruiterCompanyId=" + user : url;
    var responseJSON = yield call(postQualificationList, url);
    yield put(getQualificationSuccessful(responseJSON));
  } catch (error) {
    yield put(getQualificationFailed(error));
  }
}

function* getState({ payload: { user } }) {
  try {
    var url = constClass.REST_API_GET_STATE + user.SelectedCountry;
    const response = yield call(getRequest, url);
    yield put(setStateSuccess(response));
  } catch (error) {
    yield put(setStateFailed(error));
  }
}
function* getIplocation() {
  try {
    var url = constClass.REST_API_GET_IP_LOCATION;

    const response = yield call(getIpLocation, url);

    yield put(jobGetIpBasedLocationSuccess(response));
  } catch (error) {
    yield put(jobGetIpBasedLocationError(error));
  }
}

function* getCountries() {
  try {
    var url = constClass.REST_API_GET_COUNTRIES;

    const response = yield call(getAllCounties, url);

    yield put(setCountriesSuccess(response));
  } catch (error) {
    yield put(setCountriesFailed(error));
  }
}
function* getOrgDetails({ payload: { user } }) {
  try {
    var url = constClass.PROFILE_DETAIL_JOB;
    let obj = {
      userId: user,
    };

    const response = yield call(postProfileDetail, url, obj);

    yield put(setOrganizationDetailSuccess(response));
  } catch (error) {
    yield put(setOrganizationFailed(error));
  }
}
// get taxo job profile
function* getTaxoJobProfile({ payload: { user } }) {
  try {
    let apiurl =
      constClass.REST_API_AUTO_COMPLETE_PROFILE +
      `/?keyword=${user.keyword}&category=${user.category}`;
    var responseJSON = yield call(getRequest, apiurl);
    yield put(getTaxonomyJobProfileSuccess(responseJSON));
  } catch (error) {
    yield put(getTaxonomyJobProfileFailed(error));
  }
}
// get taxo job description
function* getTaxoJobDescrption({ payload: { user } }) {
  try {
    let apiurl =
      constClass.REST_API_AUTO_COMPLETE_PROFILE +
      `/?keyword=${user.keyword}&category=${user.category}`;
    var responseJSON = yield call(getRequest, apiurl);
    yield put(getTaxonomyJobDescriptionSuccess(responseJSON));
  } catch (error) {
    yield put(getTaxonomyJobDescriptionFailed(error));
  }
}
// get taxo job description
function* getTaxoJobSkill({ payload: { user } }) {
  try {
    let apiurl =
      constClass.REST_API_AUTO_COMPLETE_PROFILE +
      `/?keyword=${user.keyword}&category=${user.category}`;
    var responseJSON = yield call(getRequest, apiurl);
    yield put(getTaxonomyJobSKillSuccess(responseJSON));
  } catch (error) {
    yield put(getTaxonomyJobSKillFailed(error));
  }
}
//get companies list
function* getRecruiterOrganizationList({ payload: { organizationDetail } }) {
  try {
    var url = constClass.REST_API_RECRUITER_ORGANIZATION_LIST;
    const response = yield call(PostOrganizationList, url, organizationDetail);

    yield put(getRecruiterOrganizationListSuccess(response));
  } catch (error) {
    yield put(getRecruiterOrganizationListError(error));
  }
}

//get bulk import suggestion data
function* getBulkImportSuggestion({ payload: { jobBulkId } }) {
  try {
    const id = Number(jobBulkId);

    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("A valid jobBulkId is required to load the imported JD.");
    }

    const url = `${constClass.REST_API_BULK_IMPORT_SUGGESTION}?jobBulkId=${encodeURIComponent(id)}`;

    const responseJSON = yield call(getRequest, url);

    yield put(getBulkImportSuggestionSuccess(responseJSON));
  } catch (error) {
    yield put(getBulkImportSuggestionFailed(error));
  }
}
function* getNewLocation({ payload: { user } }) {
  try {
    let url = constClass.REST_API_ADD_LOCATION;

    var responsJSON = yield call(PostOrganizationList, url, user);

    yield put(addLocationSuccessful(responsJSON));
  } catch (error) {
    yield put(addLocationFailed(error));
  }
}

function* getJobIndustriesHandler(user) {
  try {
    let data = user.payload;
    let url =
      constClass.REST_API_GET_JOB_INDUSTRIES +
      `?page=${data.page}&size=${data.size}`;

    var responsJSON = yield call(getCall, url);

    yield put(getJobIndustriesSuccess(responsJSON));
  } catch (error) {
    yield put(getJobIndustriesFailed(error));
  }
}

function* getJobDegreesHandler(user) {
  try {
    let url;
    let data = user.payload;
    if (data.keyword) {
      url =
        constClass.REST_API_GET_JOB_DEGREES +
        `?page=${data.pageNumber}&size=${data.pageSize}&keyword=${data.keyword}`;
    } else {
      url =
        constClass.REST_API_GET_JOB_DEGREES +
        `?page=${data.pageNumber}&size=${data.pageSize}`;
    }

    var responsJSON = yield call(getCall, url);

    yield put(getJobDegreesSuccess(responsJSON));
  } catch (error) {
    yield put(getJobDegreesFailed(error));
  }
}

export function* watchParsingJd() {
  yield takeEvery(PARSING_JD, getParsingJd);
  yield takeEvery(ADD_JOB, addJobs);
  yield takeEvery(GET_JOB_DATA, getJobData);
  yield takeEvery(UPDATE_JOB, updateJobs);
  yield takeEvery(GET_QUALIFICATION, getQualification);
  yield takeEvery(GET_COUNTRIES, getCountries);
  yield takeEvery(GET_STATE, getState);
  yield takeEvery(JOB_GET_IP_LOCATION, getIplocation);
  yield takeEvery(GET_ORGANIZATION_DETAIL_JOB, getOrgDetails);
  yield takeLatest(GET_TAXONOMY_JOBPROFILE, getTaxoJobProfile);
  yield takeEvery(GET_TAXONOMY_JOBDESCRIPTION, getTaxoJobDescrption);
  yield takeEvery(GET_TAXONOMY_JOBSKILL, getTaxoJobSkill);
  yield takeEvery(
    RECRUITER_ORGANIZATION_DETAIL_GET_LIST,
    getRecruiterOrganizationList,
  );
  yield takeLatest(BULK_IMPORT_SUGGESTION, getBulkImportSuggestion);
  yield takeEvery(ADD_LOCATION, getNewLocation);
  yield takeEvery(GET_JOB_INDUSTRIES, getJobIndustriesHandler);
  yield takeLatest(GET_JOB_DEGREES, getJobDegreesHandler);
}

function* parsingJdSaga() {
  yield all([fork(watchParsingJd)]);
}

export default parsingJdSaga;
